import type { ReactNode } from 'react';

// Einstellungen tabellarisch (Verwaltung): je Abschnitt eine Überschrift und Zeilen mit Bezeichnung und Erklärung links,
// Eingabe rechts – auf schmalen Bildschirmen untereinander.

export function SettingsSection({ id, title, hint, children }: { id: string; title: string; hint?: ReactNode; children: ReactNode }) {
  return (
    <section id={id} className="settings-section" aria-labelledby={`${id}-title`}>
      <div className="settings-section-head">
        <h2 id={`${id}-title`}>{title}</h2>
        {hint && <p className="muted">{hint}</p>}
      </div>
      {children}
    </section>
  );
}

// SettingsRows: Tabelle der Einstellungen eines Abschnitts.
export function SettingsRows({ children }: { children: ReactNode }) {
  return <div className="settings-rows">{children}</div>;
}

// SettingRow: eine Einstellung. htmlFor verknüpft die Bezeichnung mit der Eingabe (bei mehreren Eingaben eigene Labels).
export function SettingRow({ label, hint, htmlFor, children }: { label: ReactNode; hint?: ReactNode; htmlFor?: string; children: ReactNode }) {
  return (
    <div className="setting-row">
      <div className="setting-label">
        {htmlFor ? <label htmlFor={htmlFor}>{label}</label> : <span>{label}</span>}
        {hint && <small>{hint}</small>}
      </div>
      <div className="setting-control">{children}</div>
    </div>
  );
}
